import {
  AddressInput,
  OrganizationBusinessStructure,
  OrganizationDetailFragment,
  useUpdateOrganization,
} from '@alice-financial/alice-sdk'
import { useForm, SubmitHandler } from 'react-hook-form'
import { convertPlaceToLocationInput } from '../../workLocations/locationUtils'

export interface OrganizationDetailsFormValues {
  ein: string
  tel: string
  websiteUrl: string
  businessStructure: OrganizationBusinessStructure | ''
  mcc: string
  address: AddressInput
}

export const useOrganizationDetailsForm = (org: OrganizationDetailFragment) => {
  const { mutate: updateOrganization, isLoading } = useUpdateOrganization()

  const defaultValues: OrganizationDetailsFormValues = {
    ein: org.ein || '',
    tel: org.tel || '',
    websiteUrl: org.websiteUrl || '',
    businessStructure: org.businessStructure || '',
    mcc: '5812', // TODO: Use org.mcc?.mcc?.toString() || '5812' when types are updated
    address: {
      line1: org.address?.line1 || '',
      line2: org.address?.line2 || '',
      cityName: org.address?.cityName || '',
      stateCode: org.address?.stateCode || '',
      zipcode: org.address?.zipcode || '',
    },
  }

  const form = useForm<OrganizationDetailsFormValues>({
    defaultValues,
    mode: 'onChange',
  })
  const { setValue, reset } = form

  const handleAddressSelect = (place: google.maps.places.PlaceResult) => {
    const locationInput = convertPlaceToLocationInput(place)
    if (!locationInput || !locationInput.address) return

    setValue('address', locationInput.address)
  }

  const onSubmit: SubmitHandler<OrganizationDetailsFormValues> = async (values) => {
    // Update organization details
    updateOrganization({
      input: {
        orgId: org.id,
        ein: values.ein || undefined,
        tel: values.tel || undefined,
        websiteUrl: values.websiteUrl || undefined,
        businessStructure: values.businessStructure || undefined,
        mcc: values.mcc ? parseInt(values.mcc) : undefined,
        address: values.address.line1 ? values.address : undefined,
      },
    })
  }

  return {
    ...form,
    handleAddressSelect,
    onSubmit: form.handleSubmit(onSubmit),
    isLoading,
    resetForm: () => reset(defaultValues),
  }
}
